<!-- Loading Spinner -->
<ng-container *ngIf="isLoading$ | async">
  <div class="progress progress-modal">
    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
      style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>
</ng-container>

<!-- Page Title -->
<div class="page-title-area page-title-four">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="page-title-item">
        <h2>
          {{ page == 1 ? ('MENU.HOPITALS' | translate) : ('MENU.MEDICALCENTERS' | translate) }}
        </h2>
        <ul>
          <li><a routerLink="/">{{ 'MENU.ENTITIES' | translate }}</a></li>
          <li><i class="icofont-simple-right"></i></li>
          <li>
            {{ page == 1 ? ('MENU.HOPITALS' | translate) : ('MENU.MEDICALCENTERS' | translate) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Hospitals / Medical Centers Section -->
<section class="doctors-area doctors-area-two pt-100">
  <div class="container-fluid py-5 px-lg-5">
    <div class="row justify-content-center">
      <div  [ngClass]="page == 1 ? 'col-md-5 col-sm-6' : 'col-md-3 col-sm-6'" class="mb-4" *ngFor="let hospital of Hospitals">
        <div class="card team-card text-center shadow border-0 h-100 rounded-4 p-3">
          <div class="Medical-info">
            <!-- Reduced height image -->
            <img [src]="hospital.image" alt="Hospital"
              style="object-fit: cover; width: 100%;" />

            <!-- Name (Centered) -->
            <div class="mt-4 px-2 text-center">
              <h4 class="fw-bold mb-2">
                {{ language === 'ar' ? hospital.nameAr : hospital.nameEn }}
              </h4>
            </div>
          </div>
          <!-- One-line info row -->
          <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 info-row">

            <!-- Left cluster: all info items (no text labels, just icons + values) -->
            <div class="d-flex align-items-center flex-wrap gap-4">

              <!-- Location -->
              <span class="info-item" title="City" aria-label="City">
                <i class="icofont icofont-location-pin icon-gold me-2"></i>
                <span class="info-text">{{ language === 'ar' ? hospital.locationAr : hospital.locationEn }}</span>
              </span>

              <!-- Established date -->
              <span class="info-item" title="Established" aria-label="Established">
                <i class="icofont icofont-ui-calendar icon-gold me-2"></i>
                <span class="info-text">{{ hospital.establishmentDate | date:'yyyy' }}</span>
              </span>

              <!-- Staff count -->
              <span class="info-item" title="Staff" aria-label="Staff" *ngIf="hospital.numberOfStaff > 0">
                <i class="icofont icofont-business-man icon-gold me-2"></i>
                <span class="info-text" >
                  {{ hospital.numberOfStaff }}
                </span>
              </span>

              <!-- Beds count -->
              <span class="info-item" title="Beds" aria-label="Beds" *ngIf="hospital.numberOfBeds > 0 && page == 1 ">
                <i class="icofont icofont-bed icon-gold me-2"></i>
                <span class="info-text">
                  {{ hospital.numberOfBeds }}
                </span>
              </span>

            </div>
            <!-- Right side: Read more -->
            <a *ngIf="page == 1" style="cursor: pointer;" class="read-more-link d-inline-flex align-items-center " (click)="openWebsite(hospital.website)">
              {{'ABOUTUS.READMORE' | translate}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>